'use client';

import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';

import { LayoutWithCarousel } from '@/components/Layout';
import routes from '@/constants/routes';
import { useSignupStore } from '@/store';
import type { SignupState } from '@/types';

import SignUpForm from '../components/SignUpForm';
import type { SignupFormData } from '../../engine/sign-up.model';

import '../../authentication-screens.styles.css';

const SignUpStepOne = () => {
	const navigate = useNavigate();
	const { setUser, user } = useSignupStore((state: SignupState) => state);

	const backButtonHandler = () => {
		navigate(routes['/login']);
	};

	const handleSubmit = (data: SignupFormData) => {
		// Preserve OAuth fields when updating user data from form
		setUser({
			...user,
			...data,
		});
		navigate(routes['/sign-up/create-credentials']);
	};

	return (
		<div>
			<LayoutWithCarousel>
				<Card className="sign-up-screen">
					<SignUpForm
						isLoading={false}
						onBack={backButtonHandler}
						onSubmit={handleSubmit}
					/>
				</Card>
			</LayoutWithCarousel>
		</div>
	);
};

export default SignUpStepOne;
